import { render } from "./Sale_Items.vue?vue&type=template&id=806a2b94"
import script from "./Sale_Items.vue?vue&type=script&lang=js"
export * from "./Sale_Items.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__